export const PROCESS_STAGES = [
  {
    id: "tell-us",
    title: "Tell us",
    summary: "Share your business, goals and the kind of site you need.",
    detail:
      "A short conversation or the inquiry form. We learn what you sell, who you serve, and what a visitor should do when they land on your site.",
    weDo: ["Review your current site or online presence", "Recommend pages and features", "Confirm scope and price in writing"],
    youProvide: ["Your logo and brand colors (if you have them)", "Business details: services, hours, service area", "Sites you like, and any you don't"],
  },
  {
    id: "design",
    title: "Design & approve",
    summary: "We design your homepage direction for your sign-off.",
    detail:
      "You see the look and structure before anything is built, so there are no surprises later. You approve, or ask for changes.",
    weDo: ["Design the homepage and key layouts", "Plan page structure and navigation", "Revise based on your feedback"],
    youProvide: ["Clear feedback on the design", "Photos of your work, team or location", "Final approval to start the build"],
  },
  {
    id: "build",
    title: "Build & review",
    summary: "We build every page and you review it on a private preview link.",
    detail:
      "Your site is built mobile-first, then tested on phones, tablets and large screens. You review everything on a private link before launch.",
    weDo: ["Build all pages, forms and integrations", "Test on mobile, tablet and desktop", "Set up basic on-page SEO"],
    youProvide: ["Page copy, or approval of copy we draft", "A review pass on the preview link", "Domain access (or we help you buy one)"],
  },
  {
    id: "launch",
    title: "Launch & maintain",
    summary: "We go live, then keep the site secure and up to date.",
    detail:
      "We connect your domain and launch. With Hosting & Maintenance, we handle updates, security and small edits month to month.",
    weDo: ["Connect your domain and launch", "Monitor, update and back up the site", "Make small content updates on request"],
    youProvide: ["Final go-ahead to launch", "Change requests through your client dashboard", "That's it — we handle the rest"],
  },
];
